import { lazy } from 'react'
import { Logout } from '../app/pages/Auth'

// ------------------ private Route ------------------
const Dashboard = lazy(() => import('../app/pages/private/dashboard/Dashboard'))
const UsersManagment = lazy(() =>
    import('../app/pages/private/adminRoutes/usersMangment/UserManagment')
)

const FactoryOrders = lazy(() =>
    import('../app/pages/private/factoryRoutes/factoryOrders/FactoryOrders')
)

const AllProducts = lazy(() =>
    import('../app/pages/private/adminRoutes/products/AllProducts')
)

const AdminOrders = lazy(() =>
    import('../app/pages/private/adminRoutes/order/AdminOrders')
)

const AdminAnnouncement = lazy(() =>
    import(
        '../app/pages/private/adminRoutes/adminAnnouncement/AdminAnnouncement'
    )
)

const UserAnnouncement = lazy(() =>
    import('../app/pages/private/userRoutes/UserAnnouncement/UserAnnouncement')
)

const Tickets = lazy(() =>
    import('../app/pages/private/adminRoutes/tickets/Tickets')
)

// -------------------- userRoutes -------------------
const UserOrders = lazy(() =>
    import('../app/pages/private/userRoutes/UserOrders/UserOrders')
)

// ----------------------------

export const dashboardMenuList = [
    {
        // ---------------users ----------------
        name: 'محصولات',
        icon: 'local_mall_outlined',
        path: '/dashboard/products',
        role: ['admin'],
    },
    {
        name: 'مدیر سفارشات',
        icon: 'assignment_outlined',
        path: '/dashboard/warehouseOrders',
        role: ['admin'],
    },
    {
        name: 'سفارشات من',
        icon: 'assignment_outlined',
        path: '/dashboard/myOrder',
        role: ['customer'],
    },
    {
        name: 'مدیر کارخانه',
        icon: 'business_outlined',
        path: '/dashboard/factoryOrders',
        role: ['factory_admin', 'admin'],
    },
    {
        name: 'اعلانات',
        path: '/dashboard/notifications',
        icon: 'notifications_active_outlined',
        role: ['advertising_admin', 'admin', 'customer'],
    },
    {
        name: 'مدیریت کاربران',
        path: '/dashboard/userManagments',
        icon: 'people_outlined',
        role: ['admin'],
    },
    {
        name: 'پشتیبانی',
        path: '/dashboard/tickets',
        icon: 'confirmation_number_outlined',
        role: ['admin', 'customer'],
    },
]

export const RoutesConfig = [
    //  ----------------- define auth routes --------------------
    // {
    //   Component: AuthPage,
    //   RouteType: "public",
    //   path: "/",
    //   exact: true,
    //   RouteID: "loginRegister",
    //   context: AuthContextProvider,
    // },
    {
        Component: Logout,
        RouteType: 'public',
        path: '/logout',
        exact: true,
        RouteID: 'logout',
    },

    //  ----------------- define private Routes -----------------
    {
        Component: Dashboard,
        RouteType: 'private',
        path: '/dashboard',
        exact: true,
        RouteID: 'Dashboard',
        Role: 'admin',
    },

    //  --------------------------- users ---------------------
    {
        Component: UsersManagment,
        RouteType: 'private',
        path: '/dashboard/userManagments',
        exact: true,
        RouteID: 'dashboard-userManagments',
        Role: 'admin',
    },
    {
        Component: Tickets,
        RouteType: 'private',
        path: '/dashboard/tickets',
        exact: true,
        RouteID: 'dashboard-tickets',
        Role: 'admin',
    },
    {
        Component: FactoryOrders,
        RouteType: 'private',
        path: '/dashboard/factoryOrders',
        exact: true,
        RouteID: 'dashboard-factoryOrders',
        Role: 'admin',
    },
    {
        Component: AllProducts,
        RouteType: 'private',
        path: '/dashboard/products',
        exact: true,
        RouteID: 'dashboard-products',
        Role: 'admin',
    },
    {
        Component: AdminOrders,
        RouteType: 'private',
        path: '/dashboard/warehouseOrders',
        exact: true,
        RouteID: 'dashboard-products',
        Role: 'admin',
    },
    {
        Component: AdminAnnouncement,
        RouteType: 'private',
        path: '/dashboard/notifications',
        exact: true,
        RouteID: 'dashboard-announcement',
        Role: 'admin',
    },
]

export default RoutesConfig

export const userRoutes = [
    {
        Component: Dashboard,
        RouteType: 'private',
        path: '/dashboard',
        exact: true,
        RouteID: 'Dashboard',
        Role: 'admin',
    },
    {
        Component: UserOrders,
        RouteType: 'private',
        path: '/dashboard/myOrder',
        exact: true,
        RouteID: 'dashboard-myOrder',
        Role: 'admin',
    },
    {
        Component: UserAnnouncement,
        RouteType: 'private',
        path: '/dashboard/notifications',
        exact: true,
        RouteID: 'dashboard-announcement',
        Role: 'admin',
    },
    {
        Component: Tickets,
        RouteType: 'private',
        path: '/dashboard/tickets',
        exact: true,
        RouteID: 'dashboard-tickets',
        Role: 'admin',
    },
]

export const factoryAdminRoutes = [
    {
        Component: FactoryOrders,
        RouteType: 'private',
        path: '/dashboard/factoryOrders',
        exact: true,
        RouteID: 'dashboard-factoryOrders',
        Role: 'admin',
    },
]

export const AdvertisingAdminRoutes = [
    {
        Component: AdminAnnouncement,
        RouteType: 'private',
        path: '/dashboard/notifications',
        exact: true,
        RouteID: 'dashboard-announcement',
        Role: 'admin',
    },
]
